<div class="school-address-grid" [formGroup]="formGroup">
  <div class="school-address-header blue-text">
    <h5 class="section-title">School Address</h5>
  </div>
  <div class="school-address-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="schoolAddress1" class="field-label">Street Address</label>
      <mat-form-field class="school-fields">
        <input id="schoolAddress1"
               matInput
               type="text"
               placeholder="123 Main Street"
               class="user-record-field-input"
               formControlName="schoolAddress1" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolAddress1')" />
    </div>
  </div>
  <div class="school-address-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="schoolAddress2" class="field-label">Street Address 2 (Optional)</label>
      <mat-form-field class="school-fields">
        <input id="schoolAddress2"
               matInput
               type="text"
               placeholder="Apt, Suite, etc."
               class="user-record-field-input"
               formControlName="schoolAddress2" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolAddress2')" />
    </div>
  </div>
  <div class="school-address-field half-width">
    <div class="user-record-field-wrapper">
      <label for="schoolCity" class="field-label">City</label>
      <mat-form-field class="school-fields">
        <input id="schoolCity"
               matInput
               type="text"
               placeholder="City"
               class="user-record-field-input"
               formControlName="schoolCity" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolCity')" />
    </div>
  </div>
  <div class="school-address-field half-width">
    <div class="user-record-field-wrapper">
      <label for="schoolState" class="field-label">State</label>
      <mat-form-field class="school-fields">
        <input id="schoolState"
               matInput
               type="text"
               placeholder="State"
               class="user-record-field-input"
               formControlName="schoolState"
               [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
            <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolState')" />
    </div>
  </div>
  <div class="school-address-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="schoolZip" class="field-label">Zip Code</label>
      <mat-form-field class="school-fields">
        <input id="schoolZip"
               matInput
               type="text"
               maxlength="5"
               placeholder="12345"
               class="user-record-field-input"
               formControlName="schoolZip" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolZip')" />
    </div>
  </div>
  @if (isNorthCarolina()) {
  <div class="school-address-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="schoolCounty" class="field-label">County</label>
      <mat-form-field class="school-fields">
        <input id="schoolCounty"
               matInput
               type="text"
               placeholder="County"
               class="user-record-field-input"
               formControlName="schoolCounty"
               [matAutocomplete]="countyAuto" />
        <mat-autocomplete #countyAuto="matAutocomplete">
          @for (county of filteredCounties | async; track county) {
          <mat-option [value]="county.name">{{ county.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolCounty')" />
    </div>
  </div>
  }
</div>
